import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	easyTranscribe: {
		data: {},
		isLoading: false,
		hasBeenLoaded: false,
		error: undefined
	},
	freebie: {
		data: {},
		isLoading: false,
		hasBeenLoaded: false,
		error: undefined
	}
};

export const freebiesSlice = createSlice({
	name: 'freebies',
	initialState,
	reducers: {
		getFreebieById: (state) => {
			state.freebie.isLoading = true;
		},
		getFreebieByIdCompleted: (state, action) => {
			state.freebie.data = action.payload;
			state.freebie.error = undefined;
			state.freebie.isLoading = false;
			state.freebie.hasBeenLoaded = true;
		},
		getFreebieByIdFailed: (state, action) => {
			state.freebie.isLoading = false;
			state.freebie.error = action.payload;
			state.freebie.hasBeenLoaded = false;
		},
		submitEasyTranscribe: (state) => {
			state.easyTranscribe.isLoading = true;
		},
		submitEasyTranscribeCompleted: (state, action) => {
			state.easyTranscribe.data = action.payload;
			state.easyTranscribe.error = undefined;
			state.easyTranscribe.isLoading = false;
			state.easyTranscribe.hasBeenLoaded = true;
		},
		submitEasyTranscribeFailed: (state, action) => {
			state.easyTranscribe.isLoading = false;
			state.easyTranscribe.error = action.payload;
			state.easyTranscribe.hasBeenLoaded = false;
		}
	}
});

export const {
	getFreebieById,
	getFreebieByIdCompleted,
	getFreebieByIdFailed,
	submitEasyTranscribe,
	submitEasyTranscribeCompleted,
	submitEasyTranscribeFailed
} = freebiesSlice.actions;

export default freebiesSlice.reducer;
